import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { TranslateService } from '@ngx-translate/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { PdaService } from '../../services/pda.service';
import * as moment from 'moment';
import { filter } from 'rxjs/operators';
import { Alert } from '../../models/alert.model';

@Component({
  selector: 'app-historic-details',
  templateUrl: './historic-details.component.html',
  styleUrls: ['./historic-details.component.scss'],
})
export class HistoricDetailsComponent implements OnInit {
  primaryOpen: boolean = true;
  secondaryOpen: boolean = true;
  smallSize: boolean;
  listData = [];
  format: string;

  search = '';
  modulo = 'actions';
  @Input() public planSelected: any;
  @Input() public returnToActive: boolean = false;

  @Output() public emitChangeSelected = new EventEmitter();
  @Output() public emitReturn = new EventEmitter();
  loading: boolean;
  constructor(
    private translate: TranslateService,
    private breakpointObserver: BreakpointObserver,
    private pda: PdaService
  ) {}

  ngOnInit(): void {
    const layoutChanges = this.breakpointObserver.observe([
      '(min-width: 989px)',
    ]);
    layoutChanges.subscribe((result) => {
      this.smallSize = result.matches;
    });
    this.translate.currentLang == 'es'
    ? (this.format = 'DD/MM/YYYY')
    : (this.format = 'MM/DD/YYYY');
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.getList();
    if (this.returnToActive) {
      this.returnToActives();
    }
  }
  /**
   * @name getList
   * @author Daniel Ramirez
   * @description se obtiene la lista de acciones del historico
   */
  getList() {
    this.pda.getHistoricActionList(this.planSelected.id).subscribe(
      (data: any) => {
        this.listData = data.data;

        this.listData.map((x, index, array) => {
          let id = x.id;
          x.saved = true;
          x.details = false;
          x.edit = false;
          x.num = index;
          x.hijo = 0;
          x.checked = false;
          x.etapa="No tratado";
          this.formatDates(x);
          this.actionStages(x);
         
        });
      },
      (err) => {
        console.log(err);
      }
    );
  }
  actionStages(x): void{
    
    if (x.fecha_notificacion) {
      x.etapa = 'Notificado';
    }
    if (x.fecha_inicio) {
      x.etapa = 'Planificado';
    }
    if (x.en_ejecucion == 1) {
      x.etapa = 'En ejecución';
    }
    if (x.fecha_ejecucion) {
      x.etapa = 'Ejecutado';
    }
    if (x.fecha_validacion) {
      x.etapa = 'Validado';
    }
    if ((x.etapa == 'Planificado' && x.fecha_fin) || x.etapa == 'Ejecucion') {
     const today = moment();
     const fechaFin = moment(x.fecha_fin,this.format);
      if(moment(today).isSameOrBefore(fechaFin,'day')){
        x.estado = 'En fecha';
      }else{
        x.estado = 'No en fecha';
      }
      
    }

    if (x.cerrada == 2 && x.fecha_fin) {
     const today = moment();
     const fechaFin = moment(x.fecha_fin,this.format);
      if(moment(today).isSameOrBefore(fechaFin,'day')){
        x.estado = 'En fecha';
      }else{
        x.estado = 'No en fecha';
      }
      
    }
    if (x.etapa == 'Ejecutado' || x.etapa == 'Validado') {
     const fechaFin = moment(x.fecha_fin,this.format);
     const fechaEjec = moment(x.fecha_ejecucion,this.format);
      if(moment(fechaEjec).isSameOrBefore(fechaFin,'day')){
        x.estado = 'En fecha';
      }else{
        x.estado = 'No en fecha';
      }
    }
   
  }
  formatDates(x): void{
     
    if (x.fecha_inicio) {
      x.fecha_inicio = moment(x.fecha_inicio, 'DD-MM-YYYY').format(this.format);
    }
    if (x.fecha_notificacion) {
      x.fecha_notificacion = moment(x.fecha_notificacion, 'DD-MM-YYYY').format(this.format);
    }
    if (x.fecha_fin) {
      x.fecha_fin_utc = x.fecha_fin;

      x.fecha_fin = moment(x.fecha_fin, 'DD-MM-YYYY').format(this.format);
     
    }
    if (x.fecha_ejecucion) {
      x.fecha_ejecucion_utc = x.fecha_ejecucion;
      x.fecha_ejecucion = moment(x.fecha_ejecucion, 'DD-MM-YYYY').format(this.format);
     
    }
    if (x.fecha_validacion) {
      x.fecha_validacion = moment(x.fecha_validacion, 'DD-MM-YYYY').format(this.format);
    }
  }
  openPrimary() {
    this.primaryOpen = !this.primaryOpen;
  }
  openSecondary() {
    this.secondaryOpen = !this.secondaryOpen;
  }
  /**
   * @name openInside
   * @author Daniel Ramirez
   * @description se muestran los detalles de cada accion
   */
  openInside(i) {
    this.listData[i].details = !this.listData[i].details;
  }
  /**
   * @name changeSelected
   * @author Daniel Ramirez
   * @description se emite el plan seleccionado
   */
  changeSelected(id) {
    this.emitChangeSelected.emit(id);
  }
  /**
   * @name returnToActives
   * @author Daniel Ramirez
   * @description se envian los planes seleccionados devuelta a la lista de acciones activas
   */
  returnToActives() {
    this.loading = true;
    let filter = this.listData
      .filter((x) => x.checked == true)
      .map((x) => x.id);

    let body = { accion_pda_id: filter };

    if (filter.length) {
      this.pda.reactivateActions(this.planSelected.id, body).subscribe(
        (resp) => {
          Alert.buildSuccessAlert('Acción (es) reactivada (s)');
          this.changeSelected(this.planSelected.id);
          this.getList();
          this.loading = false;

          this.emitReturn.emit(false);
        },
        (err) => {
          console.log(err);
          Alert.buildErrorAlert('Error al reactivar acción (es)');
          this.loading = false;
        }
      );
    } else {
      Alert.buildErrorAlert('Seleccione una acción');
      this.emitReturn.emit(false);
      this.loading = false;
    }
  }
}
